<template>
  <header class="site-header">
    <!-- 顶栏 -->
    <div class="top-bar">
      <div class="container flex justify-between items-center">
        <span class="top-bar-title">中跨云服 - 电子口岸入网企业在线服务平台</span>
        <div class="top-bar-right">
          <a
            class="official-link"
            href="https://www.singlewindow.com.cn"
            target="_blank"
            rel="noopener noreferrer"
          >
            中跨云服官网
          </a>
          <template v-if="!user">
            <a href="javascript:;" @click="router.push('/user/login')">登录</a>
            <span class="sep">|</span>
            <a href="javascript:;" @click="router.push('/user/register')">注册</a>
          </template>
          <template v-else>
            <a href="javascript:;" @click="router.push('/user/info')">{{ user.phone || user.username }}</a>
          </template>
        </div>
      </div>
    </div>

    <!-- Logo + 搜索 -->
    <div class="main-header">
      <div class="container flex justify-between items-center">
        <img
          class="logo-img"
          src="../assets/image/logo.svg"
          alt="logo"
          @click="router.push('/')"
        />
        <div class="search-box">
          <input
            v-model="searchVal"
            type="text"
            placeholder="请输入搜索关键字"
            @keyup.enter="searchBtn"
          />
          <button type="button" @click="searchBtn">🔍</button>
        </div>
      </div>
    </div>

    <!-- 导航栏 -->
    <div class="nav-bar">
      <div class="container flex justify-between items-center">
        <nav class="nav-links">
          <a
            v-for="item in navItems"
            :key="item.path"
            href="javascript:;"
            :class="{ on: isActive(item.path) }"
            @click="navigate(item.path)"
          >
            {{ item.label }}
          </a>
        </nav>
        <div class="nav-user" @click="goInfo">👤 管理中心</div>
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";

const searchVal = ref("");
const user = ref(null);
const route = useRoute();
const router = useRouter();

const navItems = [
  { label: "首页", path: "/" },
  { label: "制卡业务", path: "/business" },
  { label: "海关备案", path: "/#import-rights" },
  { label: "政策资讯", path: "/news" },
  { label: "常见问题", path: "/faq" },
  { label: "材料下载", path: "/material" },
];

function isActive(path) {
  if (path === "/") return route.path === "/" && !route.hash;
  if (path.startsWith("/#")) return route.path === "/" && route.hash === path.slice(1);
  return route.path.startsWith(path);
}

function navigate(path) {
  if (path.startsWith("/#")) {
    const hash = path.slice(1);
    if (route.path === "/") {
      document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
      router.replace({ hash });
      return;
    }
    router.push({ path: "/", hash });
    return;
  }
  router.push(path);
}

function goInfo() {
  const token = localStorage.getItem("access_token");
  if (!token) {
    router.push("/user/login");
  } else {
    router.push("/user/info");
  }
}

function searchBtn() {
  router.push({
    path: "/news",
    query: { keyword: searchVal.value },
  });
}

function loadUser() {
  try {
    user.value = JSON.parse(localStorage.getItem("user")) || null;
  } catch {
    user.value = null;
  }
}

watch(
  () => route.path,
  () => loadUser(),
);

onMounted(() => {
  loadUser();
});
</script>

<style lang="scss" scoped>
.site-header {
  a {
    text-decoration: none;
    color: inherit;
  }
}

/* 顶栏 */
.top-bar {
  background: #f0f0f0;
  border-bottom: 1px solid #ddd;
  height: 34px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #666;
}

.top-bar-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.top-bar-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;

  a {
    color: #666;
    padding: 0 6px;
    cursor: pointer;

    &:hover {
      color: #f07800;
    }
  }

  .sep {
    color: #ccc;
  }
}

.official-link {
  background: #f07800 !important;
  color: #fff !important;
  padding: 2px 10px !important;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 600;
  margin-right: 8px;
  transition: background 0.2s;

  &:hover {
    background: #d46000 !important;
    color: #fff !important;
  }
}

/* Logo + 搜索 */
.main-header {
  background: #fff;
  height: 68px;
  display: flex;
  align-items: center;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
}

.logo-img {
  height: 44px;
  cursor: pointer;
}

.search-box {
  display: flex;
  border: 1.5px solid #f07800;
  border-radius: 3px;
  overflow: hidden;

  input {
    border: none;
    outline: none;
    padding: 7px 12px;
    width: 180px;
    font-size: 13px;
  }

  button {
    background: #f07800;
    border: none;
    cursor: pointer;
    padding: 7px 14px;
    color: #fff;
    font-size: 14px;
    line-height: 1;

    &:hover {
      background: #d46000;
    }
  }
}

/* 导航栏 */
.nav-bar {
  background: #f07800;
  height: 40px;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
}

.nav-links {
  display: flex;
  align-items: center;

  a {
    padding: 0 16px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 14px;
    font-weight: 500;
    height: 40px;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    transition: background 0.2s;

    &:hover,
    &.on {
      background: rgba(0, 0, 0, 0.12);
      color: #fff;
    }
  }
}

.nav-user {
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .top-bar-title {
    display: none;
  }

  .search-box input {
    width: 140px;
  }

  .nav-links a {
    padding: 0 10px;
    font-size: 13px;
  }
}
</style>
